export default "__VITE_ASSET__d950bc74__"